import ApiDefault from "../../ApiDefault";

export default function ApiTypes() {
    const apiDefault = ApiDefault("v2/system/types");

    return {
        apiDefault,
    };
}
